<div class="w-full h-[4rem] flex gap-2 justify-between items-center p-2 xs:p-8 relative z-10 bg-mg-accent-base">
    
    <div class="flex items-center gap-3 flex-shrink-0">
        <button (click)="sidenav.toggle()" type="button" class="xl:hidden">
            <mg-icon iconClass="text-mg-variant" iconName="menu"></mg-icon>
        </button>
        
        <img @scaleFadeIn src="assets/svg/logo.svg" class="w-32 select-none flex-none" [class.hidden]="!isDesktop" id="logo-smart">
    </div>
    
    <div class="hidden md:flex items-center justify-center flex-grow mx-2">
        @if(marksData && myHoursData && extempData && _accessService.validarPermisoSlug('MARKS-CRUD-MODAL')){
            @if(isDesktop || (isMainDashboard$ | async)){
                <mg-interval-marks 
                    [marks_created]="marksData" 
                    [myHours]="myHoursData" 
                    [extemp_data]="extempData" 
                    [isDesktop]="isDesktop" 
                    (UpdateAttendance)="onUpdateAttendance($event)">
                </mg-interval-marks>
            }
        }
    </div>
    
    <div class="flex items-center gap-2 sm:gap-3 flex-shrink-0">
        <div (click)="goNotifications()" 
             *ngIf="!isDesktop"
             class="xl:hidden cursor-pointer flex items-center" 
             matTooltip="Notificaciones"
             matTooltipPosition="left">
            <div [matBadgeHidden]="counterNotifications <= 0"
                 [matBadge]="counterNotifications >= 100 ? '99+' : counterNotifications" 
                 matBadgeColor="warn">
                <mg-icon iconClass="text-mg-green" iconName="notifications"></mg-icon>
            </div>
        </div>
        
        <mg-version-news class="cursor-pointer" (click)="openNewsModal()"></mg-version-news>
        
        <div *ngIf="isDesktop && !(isHiddenActivity$ | async)">
            <mg-Activity></mg-Activity>
        </div>
        
        <mg-clock class="hidden xs:inline-block"></mg-clock>
        
        <button (click)="goHelp()" matTooltip="Ayuda" class="flex items-center">
            <mg-icon iconClass="text-mg-variant text-3xl sm:text-3xl" 
                     iconType="mine" 
                     iconName="ask_filled"></mg-icon>
        </button>
        
        <mg-toolbar-user></mg-toolbar-user>
    </div>
</div>